import { DateTime } from 'luxon';
import { JSON_DATETIME_FORMAT } from '../constants';

export function getUtcTimestampAsJsonString(): string {
  return DateTime.utc().toFormat(JSON_DATETIME_FORMAT);
}
